import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-34">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-35">
        <span className="text-lg font-bold text-navy-800 group-hover:text-teal-700 transition-colors" data-id="element-36">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-gray-400" data-id="element-37" /> : <ChevronDown className="h-5 w-5 text-gray-400" data-id="element-38" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-39">
        <p className="text-lg-body text-text-body" data-id="element-40">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: 'Is this medical advice?',
    answer: "No. It's an educational stabilization system that helps you communicate with your provider and troubleshoot safely."
  }, {
    question: 'What if my main issue is dry mouth?',
    answer: "Perfect—there's an entire map and protocol for it, because dry mouth has multiple causes."
  }, {
    question: "What if I have a beard / I'm a side sleeper?",
    answer: "You're exactly who this was built for. Those are common real-world failure points."
  }, {
    question: 'How fast can this help?',
    answer: 'Some improvements happen in the first week (less chaos). The bigger win is building repeatable nights across 30 days.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <FadeIn data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-12 text-center" data-id="element-44">
            Frequently Asked Questions
          </h2>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 px-8" data-id="element-45">
            {faqs.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-46" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}